import { useTranslation } from 'react-i18next';
import { FormInput, useSafeSelector } from '@unified-checkout/kit-components';
import VisaIcon from '../../assets/icons/visa.png';
import MastercardIcon from '../../assets/icons/mastercard.png';
import AmexIcon from '../../assets/icons/american-express.png';
import MadaIcon from '../../assets/icons/madacard.png'
import OmanIcon from '../../assets/icons/maal.png'
import MeezaIcon from '../../assets/icons/meezacard.png'

export function CardNumber(props: any) {
  const {
    noCardLogo,
    formRegister,
    error,
    className,
    maxLength,
    cardType,
    getCardLogo,
    customStyle,
    placeholder,
    hideCardIcons
  } = props;
  const { t } = useTranslation('card');
  const intentionData = useSafeSelector((state: any) => state.intention);
  const currency = props.currency || intentionData?.currency;

  const getLabel = () => {
    if (hideCardIcons) return;

    return getCardLogo(cardType) === '' || noCardLogo ? (
      <span className="flex gap-1 items-center justify-end w-full h-full mobile:w-auto">
      {currency === 'SAR' &&
       <img
        src={MadaIcon}
        className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
        alt="mada card icon"
      />
      }
      <img
        src={MastercardIcon}
        className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
        alt="master card icon"
      />
      <img
        src={VisaIcon}
        className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
        alt="visa card icon"
      />
      <img
        src={AmexIcon}
        className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
        alt="amex card icon"
      />
      {currency === 'OMR' &&
       <img
        src={OmanIcon}
        className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
        alt="maal card icon"
      />}
      {currency === 'EGP' &&
       <img
        src={MeezaIcon}
        className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200 px-[2px]"
        alt="meeza card icon"
      />}
    </span>
    ) : (
      !noCardLogo && (
        <span className="flex gap-1 items-center justify-end w-full h-full mobile:w-auto [&_svg]:w-7 [&_svg]:h-5">
         { getCardLogo(cardType).type === 'svg' ? getCardLogo(cardType) : <img
            className="w-7 h-5 object-contain border-solid border rounded-md border-gray-200"
            src={getCardLogo(cardType)}
            alt={cardType}
          />}
        </span>
      )
    );
  };

  return (
    <FormInput
      formRegister={formRegister}
      name={'number'}
      className={className}
      placeholder={placeholder || t('CARD_NUMBER_PLACEHOLDER')}
      label={getLabel()}
      error={error}
      maxLength={maxLength}
      inputMode="numeric"
      customStyle={customStyle}
    />
  );
}
